export const MODALIDADES = [
  { label: 'Adesão a registro de preço', value: 'Adesão a registro de preço' },
  { label: 'Concorrência', value: 'Concorrência' },
  { label: 'Chamada pública', value: 'Chamada pública' },
  { label: 'Concurso', value: 'Concurso' },
  { label: 'Convite', value: 'Convite' },
  { label: 'Dispensa de valor', value: 'Dispensa de valor' },
  { label: 'Dispensa por Locação', value: 'Dispensa por Locação' },
  { label: 'Dispensa por outros motivos', value: 'Dispensa por outros motivos' },
  { label: 'Inexigibilidade', value: 'Inexigibilidade' },
  { label: 'Leilão', value: 'Leilão' },
  { label: 'Pregão eletrônico', value: 'Pregão eletrônico' },
  { label: 'Pregão presencial', value: 'Pregão presencial' },
  { label: 'Rescisão', value: 'Rescisão' },
  { label: 'Compra direta', value: 'Compra direta' },
  { label: 'Tomada de preço', value: 'Tomada de preço' }
];



// WEBPACK FOOTER //
// ./src/app/_mocks/modalidades.ts